export enum InviteStatusEnums {
    INVITE_SENT = 'Invite Sent',
    INVITE_PENDING = 'Invite Pending',
    ONBOARDED = 'Onboarded',
}

export enum InviteStatusApiEnums {
    INVITE_SENT = "Invited",
    INVITE_RESEND = "InviteResend",
    ONBOARDED = "Active"
}

